import { produce } from 'immer';
import { first, share } from 'rxjs/operators';

import type { EffectParams } from '@swf/core/store';
import { select } from '@swf/core/store';

export const checkAuth = ({
  dispatch,
  rootState,
  actions
}: Omit<EffectParams, 'request' | 'addModel' | 'select'>) => {
  if (!select.session.isAuthenticated(rootState)) {
    dispatch.modal.enqueue({ path: '/auth/login' });
    return actions.pipe(
      first(({ type, state }) => select.session.isAuthenticated(state)),
      share()
    );
  }
  return undefined;
};

// TODO remove from casino core model utils
export interface NavItem {
  text: string;
  url: string;
}

export const getActive = (pathname: string, items: NavItem[]): string[] =>
  items
    .map((item) => item.url)
    .filter<string>((url): url is string =>
      url ? pathname.endsWith(url) || pathname.endsWith(`${url}/`) : false
    )
    .sort((a, b) => b.length - a.length);

export const initialState = { games: [], subscriptions: {}, loading: false };

// TODO simplify mock structure in casino widget stories
export const createBaseParams = (widgetId: string) => {
  const idMarker = `${widgetId}/123`;
  const baseParams = {
    backgrounds: { default: { name: 'casino', value: 'black' } },
    widgets: [{ id: idMarker, type: widgetId, config: {} }],
    reduxState: { session: { token: 'testToken', signature: 'testSignature' } }
  };
  return { idMarker, baseParams };
};

// TODO simplify mock structure in casino widget stories
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const applyParameters = (stubObject: any, widgetId: string, baseParams: any) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  produce(baseParams, (draft: any) => {
    const existingState = draft.reduxState[widgetId];
    draft.reduxState[widgetId] = { ...existingState, ...stubObject.state };
    draft.widgets[0].config = stubObject.config;
  });
